import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { environment } from 'src/environments/environment.prod';
import { MatMenuModule } from '@angular/material/menu';
import { FlexModule } from '@angular/flex-layout/flex';
@Component({
    selector: 'app-fundraiser-for-header',
    templateUrl: './fundraiser-for-header.component.html',
    styleUrls: ['../header.component.scss'],
    standalone: true,
    imports: [FlexModule, MatMenuModule]
})
/** *Fundraiser For Component */
export class FundraiserForHeaderComponent implements OnInit {
	public currentLanguageCode: string = '';
	subject = new Subject<string>();
	homeUrl = 'https:whydonate.com';
	// medical = $localize`:@@header_fundraiser_for_medical-fundraising_fundraising_url:medical-fundraising`;
	// fundraisingForEducation = $localize`:@@header_fundraiser_for_fundraising-for-education_fundraising_url:fundraising-for-education`;
	animalRescue = $localize`:@@header_fundraiser_for_animal-rescue_fundraising_url:animal-rescue`;
	charityFundraising = $localize`:@@header_fundraiser_for_charity-fundraising_fundraising_url:crowdfunding-charity`;
	climateCrisis = $localize`:@@header_fundraiser_for_climate-crisis_fundraising_url:climate-crisis`;
	coronavirusReliefFund = $localize`:@@header_fundraiser_for_coronavirus_relief_fund_fundraising_url:coronavirus-relief`;
	corporateGiving = $localize`:@@header_fundraiser_for_corporate-giving_fundraising_url:corporate-giving`;
	dendriticCellTherapy = $localize`:@@header_fundraiser_for_dendritic_cell_therapy_fundraising_url:dendritic-cell-therapy`;
	domesticViolence = $localize`:@@header_fundraiser_for_domestic-violence_fundraising_url:domestic-violence`;
	energyCrisis = $localize`:@@header_fundraiser_for_energy_crisis_fundraising_url:global-energy-crisis`;
	financialAid = $localize`:@@header_fundraiser_for_financial-aid_fundraising_url:financial-aid`;
	fireEmergency = $localize`:@@header_fundraiser_for_fire-emergency_fundraising_url:fire-emergency`;
	fundraisingForEducation = $localize`:@@header_fundraiser_for_fundraising-for-education_fundraising_url:fundraising-for-education`;
	fundraisingForFuneral = $localize`:@@header_fundraiser_for_fundraising-for-funeral_fundraising_url:fundraising-for-funeral`;
	fundraisingForNonprofits = $localize`:@@header_fundraiser_for_non-profit_fundraising_url:fundraising-for-nonprofits`;
	legalServices = $localize`:@@header_fundraiser_for_legal-services_fundraising_url:legal-services-lawyer-fees-fundraiser`;
	lgbtqCommunity = $localize`:@@header_fundraiser_for_lgbtq-community-fundraising_url:lgbtq-community-fundraiser`;
	medical = $localize`:@@header_fundraiser_for_medical-fundraising_fundraising_url:medical-fundraising`;
	msHsct = $localize`:@@header_fundraiser_for_ms_hsct_fundraising_url:hsct-ms-fundraiser`;
	music = $localize`:@@header_fundraiser_for_music_fundraising_fundraising_url:crowdfunding-music`;
	muslimCharity = $localize`:@@header_fundraiser_for_muslim-charity_fundraising_url:muslim-charity`;
	onc201 = $localize`:@@header_fundraiser_for_onc201_fundraising_url:onc201`;
	personalFundraising = $localize`:@@header_fundraiser_for-personal-fundraising_fundraising_url:personal-fundraising`;
	serviceDog = $localize`:@@header_fundraiser_for_service-dog_fundraising_url:service-dog`;
	smaDisease = $localize`:@@header_fundraiser_for_sma_ziekte_fundraising_url:sma-disease`;
	sportsFundraising = $localize`:@@header_fundraiser_for_sports-fundraising_fundraising_url:sports-fundraising`;
	supportUkraine = $localize`:@@header_fundraiser_for_support-ukraine_fundraising_url:support-ukraine`;
	surrogacyFundraiser = $localize`:@@header_fundraiser_for_surrogacy-fundraiser_fundraising_url:surrogacy-fundraiser`;
	travelExpenses = $localize`:@@header_fundraiser_for-travel-expenses_fundraising_url:travel-expenses`;
	waterDamage = $localize`:@@header_fundraiser_for_water-damage_fundraising_url:water-damage`;
	wheelchairFundraising = $localize`:@@header_fundraiser_for-wheelchair_fundraising_fundraising_url:wheelchair-accessible-van`;
	// medicalHref: any;
	// fundraisingForHref: any;
	// sportsHref: any;
	// musicHref: any;
	// crowdfundingCharityHref: any;
	// funeralHref: any;
	// nonProfitsHref: any;
	// personalFundraisingHref: any;
	// corporateGivingHref: any;
	animalRescueHref: any;
	charityFundraisingHref: any;
	climateCrisisHref: any;
	coronavirusReliefFundHref: any;
	corporateGivingHref: any;
	dendriticCellTherapyHref: any;
	domesticViolenceHref: any;
	energyCrisisHref: any;
	financialAidHref: any;
	fireEmergencyHref: any;
	fundraisingForEducationHref: any;
	fundraisingForFuneralHref: any;
	fundraisingForNonprofitsHref: any;
	legalServicesHref: any;
	lgbtqCommunityHref: any;
	medicalHref: any;
	msHsctHref: any;
	musicHref: any;
	muslimCharityHref: any;
	onc201Href: any;
	personalFundraisingHref: any;
	serviceDogHref: any;
	smaDiseaseHref: any;
	sportsFundraisingHref: any;
	supportUkraineHref: any;
	surrogacyFundraiserHref: any;
	travelExpensesHref: any;
	waterDamageHref: any;
	wheelchairFundraisingHref: any;
	constructor(
		private router: Router,
		private _accountService: AccountService,
		@Inject(LOCALE_ID) public locale: string
	) {}
	ngOnInit(): void {
		// this.getUrl().subscribe();
		this.currentLanguageCode = this._accountService.getLocaleId();
		// if (this.currentLanguageCode == 'nl') {
		//     this.animalRescueHref = `${environment.homeUrl}/${this.animalRescue}/`;
		//     this.charityFundraisingHref = `${environment.homeUrl}/${this.charityFundraising}/`;
		//     this.climateCrisisHref = `${environment.homeUrl}/${this.climateCrisis}/`;
		//     this.coronavirusReliefFundHref = `${environment.homeUrl}/${this.coronavirusReliefFund}/`;
		//     this.corporateGivingHref = `${environment.homeUrl}/${this.corporateGiving}/`;
		//     this.dendriticCellTherapyHref = `${environment.homeUrl}/${this.dendriticCellTherapy}/`;
		//     this.domesticViolenceHref = `${environment.homeUrl}/${this.domesticViolence}/`;
		//     this.energyCrisisHref = `${environment.homeUrl}/${this.energyCrisis}/`;
		//     this.financialAidHref = `${environment.homeUrl}/${this.financialAid}/`;
		//     this.fireEmergencyHref = `${environment.homeUrl}/${this.fireEmergency}/`;
		//     this.fundraisingForEducationHref = `${environment.homeUrl}/${this.fundraisingForEducation}/`;
		//     this.fundraisingForFuneralHref = `${environment.homeUrl}/${this.fundraisingForFuneral}/`;
		//     this.fundraisingForNonprofitsHref = `${environment.homeUrl}/${this.fundraisingForNonprofits}/`;
		//     this.legalServicesHref = `${environment.homeUrl}/${this.legalServices}/`;
		//     this.lgbtqCommunityHref = `${environment.homeUrl}/${this.lgbtqCommunity}/`;
		//     this.medicalHref = `${environment.homeUrl}/${this.medical}/`;
		//     this.msHsctHref = `${environment.homeUrl}/${this.msHsct}/`;
		//     this.musicHref = `${environment.homeUrl}/${this.music}/`;
		//     this.muslimCharityHref = `${environment.homeUrl}/${this.muslimCharity}/`;
		//     this.onc201Href = `${environment.homeUrl}/${this.onc201}/`;
		//     this.personalFundraisingHref = `${environment.homeUrl}/${this.personalFundraising}/`;
		//     this.serviceDogHref = `${environment.homeUrl}/${this.serviceDog}/`;
		//     this.smaDiseaseHref = `${environment.homeUrl}/${this.smaDisease}/`;
		//     this.sportsFundraisingHref = `${environment.homeUrl}/${this.sportsFundraising}/`;
		//     this.supportUkraineHref = `${environment.homeUrl}/${this.supportUkraine}/`;
		//     this.surrogacyFundraiserHref = `${environment.homeUrl}/${this.surrogacyFundraiser}/`;
		//     this.travelExpensesHref = `${environment.homeUrl}/${this.travelExpenses}/`;
		//     this.waterDamageHref = `${environment.homeUrl}/${this.waterDamage}/`;
		//     this.wheelchairFundraisingHref = `${environment.homeUrl}/${this.wheelchairFundraising}/`;
		//   } else {
		//     this.animalRescueHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.animalRescue}/`;
		//     this.charityFundraisingHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.charityFundraising}/`;
		//     this.climateCrisisHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.climateCrisis}/`;
		//     this.coronavirusReliefFundHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.coronavirusReliefFund}/`;
		//     this.corporateGivingHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.corporateGiving}/`;
		//     this.dendriticCellTherapyHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.dendriticCellTherapy}/`;
		//     this.domesticViolenceHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.domesticViolence}/`;
		//     this.energyCrisisHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.energyCrisis}/`;
		//     this.financialAidHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.financialAid}/`;
		//     this.fireEmergencyHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.fireEmergency}/`;
		//     this.fundraisingForEducationHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.fundraisingForEducation}/`;
		//     this.fundraisingForFuneralHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.fundraisingForFuneral}/`;
		//     this.fundraisingForNonprofitsHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.fundraisingForNonprofits}/`;
		//     this.legalServicesHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.legalServices}/`;
		//     this.lgbtqCommunityHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.lgbtqCommunity}/`;
		//     this.medicalHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.medical}/`;
		//     this.msHsctHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.msHsct}/`;
		//     this.musicHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.music}/`;
		//     this.muslimCharityHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.muslimCharity}/`;
		//     this.onc201Href = `${environment.homeUrl}/${this.currentLanguageCode}/${this.onc201}/`;
		//     this.personalFundraisingHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.personalFundraising}/`;
		//     this.serviceDogHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.serviceDog}/`;
		//     this.smaDiseaseHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.smaDisease}/`;
		//     this.sportsFundraisingHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.sportsFundraising}/`;
		//     this.supportUkraineHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.supportUkraine}/`;
		//     this.surrogacyFundraiserHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.surrogacyFundraiser}/`;
		//     this.travelExpensesHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.travelExpenses}/`;
		//     this.waterDamageHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.waterDamage}/`;
		//     this.wheelchairFundraisingHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.wheelchairFundraising}/`;
		//   }
		this.animalRescueHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.animalRescue}/`;
		this.charityFundraisingHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.charityFundraising}/`;
		this.climateCrisisHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.climateCrisis}/`;
		this.coronavirusReliefFundHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.coronavirusReliefFund}/`;
		this.corporateGivingHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.corporateGiving}/`;
		this.dendriticCellTherapyHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.dendriticCellTherapy}/`;
		this.domesticViolenceHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.domesticViolence}/`;
		this.energyCrisisHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.energyCrisis}/`;
		this.financialAidHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.financialAid}/`;
		this.fireEmergencyHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.fireEmergency}/`;
		this.fundraisingForEducationHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.fundraisingForEducation}/`;
		this.fundraisingForFuneralHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.fundraisingForFuneral}/`;
		this.fundraisingForNonprofitsHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.fundraisingForNonprofits}/`;
		this.legalServicesHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.legalServices}/`;
		this.lgbtqCommunityHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.lgbtqCommunity}/`;
		this.medicalHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.medical}/`;
		this.msHsctHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.msHsct}/`;
		this.musicHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.music}/`;
		this.muslimCharityHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.muslimCharity}/`;
		this.onc201Href = `${environment.homeUrl}/${this.currentLanguageCode}/${this.onc201}/`;
		this.personalFundraisingHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.personalFundraising}/`;
		this.serviceDogHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.serviceDog}/`;
		this.smaDiseaseHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.smaDisease}/`;
		this.sportsFundraisingHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.sportsFundraising}/`;
		this.supportUkraineHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.supportUkraine}/`;
		this.surrogacyFundraiserHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.surrogacyFundraiser}/`;
		this.travelExpensesHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.travelExpenses}/`;
		this.waterDamageHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.waterDamage}/`;
		this.wheelchairFundraisingHref = `${environment.homeUrl}/${this.currentLanguageCode}/${this.wheelchairFundraising}/`;
	}
}
